import { TFunction } from 'i18next'
import { isValidPhoneNumber } from 'libphonenumber-js'
import { z } from 'zod'

import { FULL_NAME_REGEX } from '@/constants'

export const makeVisitorDataSchema = (t: TFunction<['visitor-parking']>) =>
  z.object({
    email: z.email(t('visitor-parking:visitorDataForm.email.validation.invalid')),
    fullName: z
      .string()
      .min(1, t('visitor-parking:visitorDataForm.fullName.validation.required'))
      .max(30, t('visitor-parking:visitorDataForm.fullName.validation.maxLength'))
      .regex(FULL_NAME_REGEX, t('visitor-parking:visitorDataForm.fullName.validation.invalid')),
    licensePlate: z
      .string()
      .min(2, t('visitor-parking:visitorDataForm.licensePlate.validation.length'))
      .max(10, t('visitor-parking:visitorDataForm.licensePlate.validation.length')),
    phone: z
      .string()
      .min(1, t('visitor-parking:visitorDataForm.phone.validation.required'))
      .refine((value) => isValidPhoneNumber(value), {
        message: t('visitor-parking:visitorDataForm.phone.validation.invalid'),
      }),
  })

export type VisitorData = z.infer<ReturnType<typeof makeVisitorDataSchema>>

export type PaymentSession = {
  sessionId: number
  ticketNumber: string
  amount: number
  clientSecret: string | null
  visitorId: number
}
